<div>
    <button (click)="openCreateTicketDialog()" mat-stroked-button color="accent">
        <mat-icon>support_agent</mat-icon>
        VETVET kontaktieren
    </button>
</div>
